import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";
import { useState } from "react";
import { useSetMonth } from "../handles";
import { useCalendarContext } from "../context";

export default function CalendarHead() {
  const [isOpen, setIsOpen] = useState(false);
  const { onPrevMonth, onNextMonth } = useSetMonth();
  const { now } = useCalendarContext();
  const year = new Date(now).getFullYear();
  const month = new Date(now).getMonth() + 1;

  // const yearMonths = [...prevMonths.reverse(), { id: 0, year }, ...nextMonths];

  return (
    <div className="text-base font-bold flex justify-center gap-2 py-5">
      <button onClick={onPrevMonth}>
        <MdArrowBackIosNew />
      </button>
      <div className="relative">
        <button
          className="flex items-center gap-2"
          onClick={(e) => {
            setIsOpen(!isOpen);
          }}
        >
          <span>
            {year} . {(month + "").padStart(2, "0")}
          </span>
          {/* <TiArrowSortedDown size={20} data-rotate={isOpen} /> */}
        </button>
        {/* <ul hidden={!isOpen} className="mt-2">
          {yearMonths.map((yr) => {
            return (
              <li key={yr.year} className="mt-[1px]">
                <button
                  ref={yearRef}
                  id={yr.year === year ? "crr-year" : ""}
                  className="w-full h-[22px] text-sm text-white  font-bold bg-navy-300"
                  onClick={(e) => {
                    const next = e.currentTarget.nextSibling as HTMLDivElement;
                    const visible = next.hidden;
                    if (visible) {
                      next.hidden = false;
                    }
                    if (!visible) {
                      next.hidden = true;
                    }
                  }}
                >
                  {yr.year}
                </button>
                <div hidden>
                  <ul
                    className={
                      "flex justify-center w-[160px] flex-wrap border-1 "
                    }
                  >
                    {mths.map((item) => {
                      return (
                        <li
                          key={item.value}
                          data-crr={year === yr.year && month === item.value}
                          className=""
                          onClick={(e) => {
                            const selected = new Date(yr.year, item.value, 0);

                            setNow(selected);
                            setIsOpen(!isOpen);
                          }}
                        >
                          {item[langCd as keyof lngProps]}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>
            );
          })}
        </ul> */}
      </div>
      <button onClick={onNextMonth}>
        <MdArrowForwardIos />
      </button>
    </div>
  );
}
